import React, { useEffect, useState } from 'react';

import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { classNameType } from 'utils/types';

import s from './CircleProgressBar.module.scss';

const cx = cn.bind(s);

const CircleProgressBar = ({
  theme = 'mint', animationDelay = 850, size = 25, progress = 0, strokeWidth = 2, hasProgress = true, className, ...attrs
}) => {
  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius; // C
  const progressOffset = ((100 - progress) / 100) * circumference;
  const [offset, setOffset] = useState(animationDelay ? circumference : progressOffset);
  useEffect(() => {
    let delay;
    if (animationDelay) {
      delay = setTimeout(() => setOffset(progressOffset), animationDelay);
    }
    return () => clearTimeout(delay);
  }, [setOffset, progress, circumference, offset, progressOffset, animationDelay]);

  return (
    <div
      className={cx('circleProgressBar', theme, className)}
      style={{
        '--circle-progress-width': `${size}px`,
        '--circle-progress-height': `${size}px`,
      }}
      {...attrs}
    >
      <svg
        className={cx('svg')}
        width={size}
        height={size}
      >
        <circle
          className={cx('svgCircleBg')}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className={cx('svgCircle')}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90, ${center}, ${center})`}
        >
          {!!animationDelay && <animate
            attributeName="stroke-dashoffset"
            dur={`${animationDelay}ms`}
            values={`${circumference};${progressOffset}`}
          />}
        </circle>
      </svg>
      {hasProgress && <div className={cx('svgCircleText', 'tp-subheader')}>
        {`${progress}%`}
      </div>}
    </div>
  );
};

CircleProgressBar.propTypes = {
  theme: PropTypes.string,
  animationDelay: PropTypes.number,
  size: PropTypes.number,
  progress: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  className: classNameType,
};

export default CircleProgressBar;
